import { Component, ElementRef, OnInit, TemplateRef, ViewChild, Input } from '@angular/core';
import { AppService } from '../app.service';
import { qmsService } from '../../app/qms/qms.service';
import { Router } from '@angular/router';
import { Chart } from 'chart.js/auto'
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PaginationService } from '../PaginationService';
import { messageService } from '../message.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MsalService } from '@azure/msal-angular';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { GridReorderComponent } from '../grid-reorder/grid-reorder.component';
import { ExcelPdfComponent } from '../support/excel-pdf/excel-pdf.component';
import { DocViewerConfig } from '../support/models/doc-viewer-config.model';
import { DocumentViewerComponent } from '../support/document-viewer/document-viewer.component';
export interface PopupData {
  title: string;
}
@Component({
  selector: 'app-training-dashboard',
  templateUrl: './training-dashboard.component.html',
  styleUrls: ['./training-dashboard.component.scss']
})

export class TrainingDashboardComponent implements OnInit {
  // circular indicator
  color: '#005C8A';
  value = 90;

  chart: any;
  teamChart: any;
  isProcessing = false;
  trainingCountList: any = [{
    levelStatus: "Completed",
    trainingCount: 0,
    color: "#96E480"
  }, {
    levelStatus: "In Progress",
    trainingCount: 0,
    color: "#00A6A9"
  }, {
    levelStatus: "Yet to Start",
    trainingCount: 0,
    color: "#BA7393"
  }];
  gridTemp: any = [];
  date: any;
  totalList: any = [];
  statusList: any = [];
  colorList: any = [];
  currentOrgId: number;
  rawJsonResponse: any = null;
  activeApi: string = '';
  initialCount = 0;
  pageCount = 4;
  isPrevious = false;
  isNext = false;
  dashStatus: any;
  trainingCount = 0;
  trainingName = "";
  trainingCode = "";
  trainingGroup = "";
  selectedTrainingCategory: any = [];
  selectedTrainingCategoryValue: any = "";
  dropDownForCategories: any = [];
  categoryDropdown: any = [];
  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  visibleSearchTrainingPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('searchTrainingpopup', { static: true }) searchTrainingpopup: TemplateRef<any>;
  visibleTeamTrainingPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('teamTrainingPopup', { static: true }) teamTrainingPopup: TemplateRef<any>;
  visibleSearchTrainingGroupPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('searchTrainingGroupPopup', { static: true }) searchTrainingGroupPopup: TemplateRef<any>;
  visibleTrainingProfilePopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('trainingProfilepopup', { static: true }) trainingProfilepopup: TemplateRef<any>;

  searchTrainingPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  teamTrainingPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  searchTrainingGroupPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  trainingProfilePopupConfig = {
    width: '800px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  constructor(private readonly appService: AppService, private readonly router: Router, public dialog: MatDialog, public qmsservice: qmsService, public paginationService: PaginationService,
    public message: messageService, private readonly elem: ElementRef, private readonly snackBar: MatSnackBar, private readonly authService: MsalService) {

  }

  managerCount = 0;
  totalCompleted = 0;
  totalNotCompleted = 0;
  trainingTaskDetails: any = [];
  userDetails: any = {};
  userGroups: any = [];
  userDocuments: any = [];
  myReportTraining: any = [];
  categoryCount: any;
  groupCount: any;
  documentsCount: any;
  reportCount: any;
  badgeName: any = "";
  memberData: any;
  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    minDate: new Date()
  }
  tmsSettingsObj: any;
  dateCustomClasses: DatepickerDateCustomClasses[];
  isAdenabled: boolean = false;
  displayUserName: any;
  userAuthorizedCategories: any = [];
  ngOnInit(): void {
    this.currentOrgId = Number(this.message.getOrgId());
    if (this.currentOrgId === 10071) {
      this.isProcessing = false;
      return; 
    }
    let userData = JSON.parse(sessionStorage.getItem("userDetails") ?? '{}')
    this.displayUserName = userData.userNameAtApplication;
    this.date = new Date();
    if (this.appService.myTraining == "homePage") {
      this.selectedWizard = "Team Trainings"
      this.selectedSubWizardofTeam = "Team Members"
    }
    this.isAdenabled = localStorage.getItem("adEnabled") == 'Y';
    this.appService.getBadgeRangeForTmsUser().subscribe((data: any) => {
      if (data.length > 0) {
        this.badgeName = data[0];
      }
    })
    this.userName = localStorage.getItem("loggedUserName");
    this.appService.getTmsSettingsVwDetails().subscribe((response: any) => {
      if (response) {
        this.tmsSettingsObj = response;
      } else {
        this.tmsSettingsObj = {};
      }
    });
    this.appService.getUserDetailsForTrainingDashboard().subscribe((data: any) => {
      this.userDetails = data[0];
    })
    this.appService.getGroupsForTrainingDash().subscribe((data: any) => {
      this.userGroups = data;
      this.groupCount = this.userGroups.length;
    })

    this.appService.getDocumentsForTrainingDash().subscribe((data: any) => {
      this.userDocuments = data;
      this.documentsCount = this.userDocuments.length;
    })

    this.appService.getOneQmsUserTrainingsRepVwDetails(null, "user", "NeedConsiderForReport", " AND USER_ID=" + this.message.getUserId(), "No").subscribe((data: any) => {
      this.myReportTraining = data;
      this.reportCount = this.myReportTraining.length;
    })


    this.appService.userPrivsDetails(this.userId).subscribe((data: any) => {
      console.log('userPrivsDetails API Response:', data);
      const trainingAuthorCategories = data.trainingAuthorCategories;
      console.log('trainingAuthorCategories:', trainingAuthorCategories);

      if (trainingAuthorCategories && trainingAuthorCategories.trim() !== '') {
        const categoriesArray = trainingAuthorCategories.split(',').filter((item: string) => item.trim() !== '');
        this.categoryCount = categoriesArray.length;
        console.log('Training Categories Count:', this.categoryCount);
        console.log('Categories Array:', categoriesArray);

        // Store the authorized categories for display
        this.userAuthorizedCategories = categoriesArray.map((categoryName: string) => ({
          trainingCategoryName: categoryName.trim()
        }));
      } else {
        this.categoryCount = 0;
        this.userAuthorizedCategories = [];
      }

      // Still get all categories for dropdown if needed
      this.appService.getAllCategoriesList().subscribe((categoryData: any) => {
        this.dropDownForCategories = categoryData;
        for (const category of this.dropDownForCategories) {
          this.categoryDropdown.push({
            valueExp: category.trainingCategoryCode,
            displayExp: category.trainingCategoryName
          });
        }
      });
    })
    this.appService.managerCount().subscribe((data: any) => {
      if (data.length > 0) {
        this.managerCount = data.length;
        this.memberData = data;
      }
    })
    this.isProcessing = true;
    this.appService.getTrainingsRepCount().subscribe((data: any) => {
      this.isProcessing = false;
      let k = 2;
      for (const item of data) {
        if (item.levelStatus === "Pending") {
          item.color = "#BA7393";
          item.levelStatus = "Yet to Start";
          this.trainingCountList[2] = item;
        } else if (item.levelStatus === "In Progress") {
          item.color = "#00A6A9";
          this.trainingCountList[1] = item;
        } else if (item.levelStatus === "Completed") {
          item.color = "#96E480";
          this.trainingCountList[0] = item;
        } else {

          k++;

          if (item.levelStatus === "Pending(Next Level)" && item.trainingCount >= 1) {
            item.color = "#0081A5";
            item.levelStatus = "Next Levels";
          } else if (item.levelStatus === "Failed" && item.trainingCount >= 1) {
            item.color = "#834160";
          } else if (item.levelStatus === "Locked" && item.trainingCount >= 1) {
            item.color = "#6B7887";
          } else if (item.levelStatus === "Locked Overdue" && item.trainingCount >= 1) {
            item.color = "#FF3A29";
          } else if (item.levelStatus === "Locked Overdue(RM Approved)" && item.trainingCount >= 1) {
            item.color = "#9EADBD";
          } else {
            item.color = "#f2f2f2";
          }

          this.trainingCountList[k] = item;
        }

        this.totalList.push(item.trainingCount);
        this.colorList.push(item.color ?? "#f2f2f2");

        this.trainingCount += item.trainingCount;
      }
      if (data.length > 0) {
        this.chart = null;
        this.createChart(this.totalList, this.statusList, this.colorList);
      } else {
        this.chart = null;
        this.createChart(['100'], [''], ['gray']);
      }


    })
    this.appService.getTeamDetailsByStatuswise()
      .subscribe((data: any) => {
        const items = data ?? [];

        for (const item of items) {
          this.totalCompleted += item.completed ?? 0;
          this.totalNotCompleted += item.notCompleted ?? 0;
        }
        this.createChartForTeam([this.totalCompleted, this.totalNotCompleted], ["Completed", "Not Completed"], ["#96E480", "#BA7393"]);
      })
    this.appService.getTrainingTaskDetails()
      .subscribe((data: any) => {
        this.trainingTaskDetails = data;
      })
    this.isProcessing = true;
    this.dashStatus = "Yet to Start";
    this.appService.getTrainingListByStatusforRep("Pending")
      .subscribe((data: any) => {
        this.isProcessing = false;
        if (data.length > 0) {
          this.trainingList = data;
          this.initialCount = 0;
          this.pageCount = 4;
          this.selectedTraining = 2 + '_' + this.dashStatus;
          this.isPrevious = false;
          if (this.pageCount < this.trainingList.length) {
            this.isNext = true;
          } else if (this.pageCount >= this.trainingList.length) {
            this.isNext = false;
          }
          const now = new Date();
          for (const training of this.trainingList ?? []) {
            training.isOverdue = training.dueDate < now;
          }
        } else {
          this.dashStatus = "In Progress";
          this.appService.getTrainingListByStatusforRep("In Progress")
            .subscribe((data: any) => {
              this.trainingList = data;
              this.initialCount = 0;
              this.pageCount = 4;
              this.isPrevious = false;
              this.selectedTraining = 1 + '_' + this.dashStatus;
              if (this.pageCount < this.trainingList.length) {
                this.isNext = true;
              } else if (this.pageCount >= this.trainingList.length) {
                this.isNext = false;
              }
              const now = new Date();

              for (const training of this.trainingList ?? []) {
                training.isOverdue = training.dueDate < now;

                this.getContentListAndCalculateProgress(training);
              }
            })
        }
      })

    this.isProcessing = true;
    this.appService.getOneQmsOrganizationReportImage().subscribe({
      next: (data: any) => {
        this.organizationReportImageDetails = data;
        this.appService.getQmsReportLogoByModuleAndGroupId("TRN", 0).subscribe((data: any) => {
          this.dropDownDataForReportLogo = data;
          this.selectBoxForReportLogo();
          this.isProcessing = false;
        });
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    })

    this.ngOnChangesReportFooter();
  }

  focusEmpty() {
    console.log();
  }


  getContentListAndCalculateProgress(trainingData: any) {
    this.appService.getContentsList(trainingData['trainingId'],
      trainingData['version']).subscribe((data: any) => {
        let total = data.length;
        let statusCount = 0;
        for (const item of data ?? []) {
          if (item.status === "Completed") {
            statusCount += 1;
          }
        }
        let newNum: any = (statusCount / total) * 100;
        trainingData.progress = Number(Number.parseFloat(newNum)).toFixed(0);
        if (total == statusCount && trainingData.levelStatus == 'In Progress') {
          trainingData.progress = 90;
        }
      })
  }

  addBadges(badgeName: any) {
    if (badgeName) {


      const hyperRemoveData: string = badgeName.replaceAll('-', '');
      const badge: string = hyperRemoveData.replaceAll(/\s/g, '');
      const newBadge: string = badge[0].toUpperCase() + badge.substring(1).toLowerCase();
      let imagePath = '../../assets/img/' + newBadge + '.png';
      return {
        "background": "transparent url(" + imagePath + ") no-repeat center 35px",
        "margin-left": "-4%"
      };
    } else {
      return null;
    }
  }
  createChart(totalList: any, statusList: any, colorList: any) {

    this.chart = new Chart("MyChart", {
      type: 'doughnut', //this denotes tha type of chart

      data: {// values on X-Axis
        datasets: [{

          data: totalList,
          backgroundColor: colorList,
          hoverOffset: 4,

        }],
      },
      options: {
        responsive: true,
        cutout: '80%',
        plugins: {
          tooltip: {
            enabled: false
          },
        },
        elements: {

        }
      }
    });
  }

  createChartForTeam(totalList: any, statusList: any, colorList: any) {

    this.teamChart = new Chart("MyChartForTeamMember", {
      type: 'doughnut', //this denotes tha type of chart

      data: {// values on X-Axis
        datasets: [{

          data: totalList,
          backgroundColor: colorList,
          hoverOffset: 4,

        }],
      },
      options: {
        responsive: true,
        cutout: '80%',
        //  circumference : 180,
        //  rotation : 270,
        plugins: {
          tooltip: {
            enabled: false
          },

        },
        elements: {

        }
      }
    });
  }

  viewStatuswiseTraining1(e: Event, status: any, index: any) {
    this.selectedWizard = "My Trainings";
    this.viewStatuswiseTraining(e, status, index);
  }


  trainingList: any = [];
  selectedTraining: any;
  selectedTeamTraining: any;
  viewStatuswiseTraining(e: Event, status: any, index: any) {
    e.preventDefault();
    this.selectedTraining = index;
    this.dashStatus = status;
    if (status == "Next Levels") {
      status = "Pending(Next Level)";
    }
    if (status == "Yet to Start") {
      status = "Pending";
    }
    this.isProcessing = true;
    this.appService.getTrainingListByStatusforRep(status)
      .subscribe((data: any) => {
        this.isProcessing = false;
        this.trainingList = data;
        this.initialCount = 0;
        this.pageCount = 4;
        this.isPrevious = false;
        if (this.pageCount < this.trainingList.length) {
          this.isNext = true;
        } else if (this.pageCount >= this.trainingList.length) {
          this.isNext = false;
        }
        const now = new Date();
        const isInProgress = this.dashStatus === 'In Progress';
        for (const training of this.trainingList ?? []) {

          training.isOverdue = training.dueDate < now;

          if (isInProgress) {
            this.getContentListAndCalculateProgress(training);
          }
        }
      })
  }

  previousClick(data: any) {
    this.pageCount = this.pageCount - 4;
    this.initialCount = this.initialCount - 4;

    if (this.pageCount < data.length) {
      this.isNext = true;
    } else if (this.pageCount >= data.length) {
      this.isNext = false;
    }

    if (this.initialCount) {
      this.isPrevious = true;
    } else {
      this.isPrevious = false;
    }
  }

  nextClick(data: any) {
    this.pageCount = this.pageCount + 4;
    this.initialCount = this.initialCount + 4;
    if (this.pageCount < data.length) {
      this.isNext = true;
    } else if (this.pageCount >= data.length) {
      this.isNext = false;
    }

    if (this.initialCount) {
      this.isPrevious = true;
    } else {
      this.isPrevious = false;
    }
  }

  launchTrainingFunc(training: any) {
    training['searchedTraining'] = false;
    this.appService.setTrainingDetails(null, training);
    this.router.navigate(['/dashboard/trainingDashboardDetail'])
  }

  applyStyle(value: any) {
    return {
      "background-color": value
    };
  }

  applyStyleForTraining(value: any) {
    return {
      "border-color": ''
    };
  }



  onCategorySelect(item: any) {
    this.selectedTrainingCategoryValue = item.valueExp;
  }
  onCategoryRemoved(item: any) {
    this.selectedTrainingCategoryValue = "";
  }

  resetSearchTraining() {
    this.trainingName = "";
    this.trainingCode = "";
    this.selectedTrainingCategoryValue = "";
    this.selectedTrainingCategory = [];
    this.selectedLanguageValue = "";
    this.trainingGroup = "";
    this.trainingGroupId = "";

  }

  selectedLanguageValue = "";
  searchedTrainingsList: any = [];
  trainingGroupId: any = "";
  searchTrainings() {
    this.searchedTrainingsList = [];
    this.pagedItems = [];
    let data = {
      trainingName: this.trainingName,
      trainingCode: this.trainingCode,
      category: this.selectedTrainingCategoryValue,
      language: this.selectedLanguageValue,
      groupId: this.trainingGroupId
    };
    if (this.trainingGroupId != null && this.trainingGroupId != "") {
      this.isProcessing = true;
      this.appService.searchTrainingsByConditionFromGroups(data).subscribe((response: any) => {
        this.searchedTrainingsList = response;
        for (const training of this.searchedTrainingsList ?? []) {
          training.groupName = this.trainingGroup;
        }
        this.isProcessing = false;
        this.collectionSize = this.searchedTrainingsList.length;
        this.pager.totalPages = undefined;
        this.setPage(1, 0);
      })
    } else {
      this.isProcessing = true;
      this.appService.searchTrainingsByConditionForScheduler(data).subscribe((response: any) => {
        this.searchedTrainingsList = response;
        this.isProcessing = false;
        this.collectionSize = this.searchedTrainingsList.length;
        this.pager.totalPages = undefined;
        this.setPage(1, 0);
      })
    }

    this.visibleSearchTrainingPopup = this.dialog.open(this.searchTrainingpopup, this.searchTrainingPopupConfig);
  }

  cancelSearchTrainingPopup() {
    this.visibleSearchTrainingPopup.close();
  }


  showingRowsText = "Showing rows";
  perPage = 10;
  itemsPerPage = 20;
  maxSize = 3;
  collectionSize: number;
  pager: any = {};
  pagedItems: any[];
  pagedItemsForDoc: any[];
  makeStickyColumns: any;

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  pagedItemsForTeam: any = [];
  setPage1(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.tmsUserTrainingsRepVwDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItemsForTeam = this.tmsUserTrainingsRepVwDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall1(value: number) {
    this.perPage = value;
    this.setPage1(this.pager.currentPage, 0);
  }

  setPage2(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.userDocuments.length, page, this.perPage, targetpage);
    this.pagedItemsForDoc = this.userDocuments.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall2(value: number) {
    this.perPage = value;
    this.setPage2(this.pager.currentPage, 0);
  }

  goToDetailPage(training: any, e: Event) {
    e.preventDefault();
    this.visibleSearchTrainingPopup.close();
    training['searchedTraining'] = true;
    this.appService.setTrainingDetails(null, training);
    this.router.navigate(['/dashboard/trainingDashboardDetail'])
  }

  searchedTrainingGroupList: any = [];
  showTrainingGroupSearchGrid: boolean = false;
  searchByGroupName: any = "";
  searchTrainingGroupsFunc() {
    this.searchByGroupName = null;
    this.searchedTrainingGroupList = [];
    this.showTrainingGroupSearchGrid = false;
    this.trainingGroup = "";
    this.trainingGroupId = "";
    this.visibleSearchTrainingGroupPopup = this.dialog.open(this.searchTrainingGroupPopup, this.searchTrainingGroupPopupConfig);
  }

  usergroupData: any = {};
  searchTrainingGroupChildCheckBoxChecked(event: any, userGroup: any, index: any) {
    if (event.target.checked) {
      userGroup.searchTrainingChildCheckBoxs = true;
      this.usergroupData = userGroup;
    } else {
      userGroup.searchTrainingChildCheckBoxs = false;
      this.usergroupData = {};
    }
  }

  resetSearchTrainingGroupGridDataFunction() {
    this.isProcessing = true;
    this.searchByGroupName = null;
    this.searchedTrainingGroupList = [];
    this.showTrainingGroupSearchGrid = false;
    this.isProcessing = false;
  }

  searchTrainingGroupGridDataFunction() {
    let data = {
      groupName: this.searchByGroupName,
    };
    this.isProcessing = true;
    this.appService.searchTmsGroups(data).subscribe((response: any) => {
      this.searchedTrainingGroupList = response;
      this.showTrainingGroupSearchGrid = true;
      this.isProcessing = false;
    })
  }

  cancelSearchTrainingGroupFunction() {
    this.visibleSearchTrainingGroupPopup.close();
  }

  addTrainingGroupFunction() {
    this.trainingGroup = this.usergroupData.groupName;
    this.trainingGroupId = this.usergroupData.groupId;
    this.visibleSearchTrainingGroupPopup.close();
  }

  goToManagePage1(task: any, id: any) {
    this.selectedWizard = "Training Actions";
    this.goToManagePage(task, id);
  }

  goToTeamMemberPage(value: any) {
    this.selectedWizard = "Team Trainings"
    this.openSubTabOfTeam(value);
  }

  teamPopupTitle = "";

  tmsUserTrainingsRepVwDataForGrid: any = [];
  tmsUserTrainingsRepVwDataForGrid1: any = [];
  searchVals: any = "";
  type: any = "";
  columnLists: any = [];
  dataTypeList: any = [];
  totalPages = 0;
  calculateTotalPages: number;
  userId: number = Number(this.message.getUserId());
  getcallMethod() {

    this.tmsUserTrainingsRepVwDataForGrid = [];
    const data = {

      gridName: "USER_TRAINING_REPORT",
      groupId: null
    }
    this.isProcessing = true;
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        this.isProcessing = false;
        response.orderByClause ??= "";

        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: "TMS_USER_TRAININGS_REP_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          searchVal: this.userId,
          additionalSearchVal: null,
          searchStatus: this.searchVals,
          repType: "rm",
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.isProcessing = true;
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.isProcessing = false;
            this.tmsUserTrainingsRepVwDataForGrid = response1;
            if (!this.selectedTeamTraining) { // simpler null/empty check
              console.log('Full Data:', this.tmsUserTrainingsRepVwDataForGrid);

              // ✅ Extract unique STATUS values
              const uniqueStatuses = [
                ...new Set(
                  (this.tmsUserTrainingsRepVwDataForGrid || [])
                    .map((item: any) => item.STATUS)
                    .filter((status: any) => status != null && status !== '')
                )
              ];

              // ✅ Store the result
              this.tmsUserTrainingsRepVwDataForGrid1 = uniqueStatuses;

              console.log('Unique STATUS values:', this.tmsUserTrainingsRepVwDataForGrid1);
            }
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1?.fieldSizeListArray ?? []) {
              this.columnLists.fieldSizeListArray.push(`${size}px`);
            }

            let currentIndex = 0;
            const columnsCopy = [...(this.columnLists.columnsListarray ?? [])];
            const invisibleColumns = this.columnLists.invisibleColumnarray ?? [];

            for (const column of columnsCopy) {
              if (invisibleColumns.includes(column)) {

                this.columnLists.columnsListarray.splice(currentIndex, 1);
                this.columnLists.fieldColumnarray.splice(currentIndex, 1);
                this.columnLists.fieldSizeListArray.splice(currentIndex, 1);
              } else {
                currentIndex++;
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.isProcessing = true;
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.isProcessing = false;
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const typeInfo of this.dataTypeList ?? []) {
                  if (typeInfo.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = typeInfo.fieldType;
                  }
                }
              }

              const checkboxColumns: string[] = [];
              for (const dt of (this.dataTypeList ?? [])) {
                if (dt.fieldType === 'CHECKBOX') {
                  checkboxColumns.push(dt.columnName);
                }
              }
              for (const row of (this.tmsUserTrainingsRepVwDataForGrid ?? [])) {
                for (const colName of checkboxColumns) {
                  row[colName] = row[colName] === "Y";
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage1(1, 0);
            });
            this.message.gridList = this.tmsUserTrainingsRepVwDataForGrid;
            this.collectionSize = this.tmsUserTrainingsRepVwDataForGrid.length;
            this.totalPages = Math.ceil(this.tmsUserTrainingsRepVwDataForGrid.length / this.itemsPerPage);
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  globalFilter(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.tmsUserTrainingsRepVwDataForGrid;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.tmsUserTrainingsRepVwDataForGrid == undefined) {
        return this.tmsUserTrainingsRepVwDataForGrid;
      }
      if (!this.tmsUserTrainingsRepVwDataForGrid.length) {
        return this.tmsUserTrainingsRepVwDataForGrid;
      }
      if (filter) {
        this.gridTemp = this.tmsUserTrainingsRepVwDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.tmsUserTrainingsRepVwDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedOrSearch(1, 0);
    }
  }
  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetPage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }
  coloumnFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItemsForTeam = this.tmsUserTrainingsRepVwDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItemsForTeam = this.tmsUserTrainingsRepVwDataForGrid.filter((item: any) => {
        const propertyValue = item[column]?.toString().toLowerCase();
        return propertyValue?.includes(filter);
      });
    }
  }
  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.tmsUserTrainingsRepVwDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.tmsUserTrainingsRepVwDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  cancelTeamTrainingPopup() {
    this.visibleTeamTrainingPopup.close();
  }

  trainingProfileTitle: any;
  openInformationPopup(popupData: any, event: any) {
    event.preventDefault();
    this.trainingProfileTitle = popupData;
    this.visibleTrainingProfilePopup = this.dialog.open(this.trainingProfilepopup, this.trainingProfilePopupConfig);
    if (popupData == 'Documents') {
      this.collectionSize = this.userDocuments.length;
      this.pager.totalPages = undefined;
      this.setPage2(1, 0);
    }
  }

  cancelTrainingProfilePopup() {
    this.visibleTrainingProfilePopup.close();
  }

  trainingActionsList: any = [];
  selectedTrainingAction: any = {};
  goToManagePage(data: any, index: any) {
    this.selectedTrainingAction = data;
    this.selectedTraining = index;
    this.isProcessing = true;
    this.trainingActionsList = [];
    let obj = {

      module: "TRN",
      status: data.status,
      isFrom: "All"
    }
    this.appService.getTaskDetailData(obj)
      .subscribe((data: any) => {
        this.trainingActionsList = data;
        this.isProcessing = false;
        this.initialCount = 0;
        this.pageCount = 4;
        this.isPrevious = false;
        if (this.pageCount < this.trainingActionsList.length) {
          this.isNext = true;
        } else if (this.pageCount >= this.trainingActionsList.length) {
          this.isNext = false;
        }
      })
  }

  selectedWizard = "My Trainings";
  openMainTab(val: any) {
    this.selectedWizard = val;
    if (this.selectedWizard == "Training Actions") {
      if (this.trainingTaskDetails.length > 0) {
        this.goToManagePage(this.trainingTaskDetails[0], "0_" + this.trainingTaskDetails[0].status);
      }

    }
  }

  selectedSubWizardofTeam = "Team Members";
  trainingObj: any = {};
  isShowDueDate = false;
  dueDate: any;
  title: any;
  trainingData: any = {};
  userName: any;
  password: any = "";
  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmWithReasonPopup', { static: true }) confirmWithReasonPopup: TemplateRef<any>;

  confirmWithReasonPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };
  openSubTabOfTeam(val: any) {
    this.selectedSubWizardofTeam = val;
    this.selectedTeamTraining = null;
    if (val == "Completed") {
      this.teamPopupTitle = val;
      this.searchVals = val;
    } else {
      this.teamPopupTitle = "Not Completed";
      this.searchVals = "notCompleted";
    }
    this.getcallMethod();
  }

  openSubTabOfTeamNotCompleted(val: any) {
    this.selectedTeamTraining = val;
    this.teamPopupTitle = val;
    this.searchVals = val;
    this.getcallMethod();
  }
  updateTrainingFunc(training: any) {

    if (training.status.includes("Locked")) {
      this.dueDate = null;
      this.title = training.status;
      this.isProcessing = true;
      this.changetypeAddAndEditPassword = true;

      this.appService.getUserTrainingsByTrainingId(training.taskNo).subscribe((data: any) => {
        this.trainingData = data[0];
        this.isProcessing = false;
        if (training.status == "Locked Overdue(RM Approved)" || training.status == "Locked Overdue") {
          this.isShowDueDate = true;
          this.isProcessing = true;
          this.appService.getGroupTrainingDetailsById(this.trainingData.groupId,
            this.trainingData.trainingId, this.trainingData.version).subscribe((data: any) => {
              this.isProcessing = false;
              if (data.length > 0 && data[0].dueNDayFromOverdueUnlock != null) {
                this.dueDate = new Date();
                this.dueDate.setDate(new Date().getDate() + data[0].dueNDayFromOverdueUnlock)
              }
            })
        } else {
          this.isShowDueDate = false;
        }
      })
      this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
    } else {
      this.trainingObj = training;
      this.trainingObj['isFromDashboard'] = false;
      this.isProcessing = true;
      this.appService.getAllCategoriesList().subscribe((data: any) => {
        this.dropDownForCategories = data;
        this.appService.getTrainingByTrainingId(training.taskNo, training.version)
          .subscribe((data: any) => {
            this.isProcessing = false;
            this.appService.setTrainingDetails(this.dropDownForCategories, data[0]);
            this.message.breadcrumbData.thirdLevel = "Add Training";

            this.router.navigate(['/dashboard/addTraining']);
          })
      })
    }
  }

  confirmWithFuncCall() {
    let data1 = {
      userTrainingId: this.trainingData.userTrainingId,
      dueDate: this.dueDate ? this.appService.dateZoneConvertion(new Date(this.dueDate)) : null
    };
    this.isProcessing = true;
    this.appService.unlockTraining(data1).subscribe({
      next: (data: any) => {
        this.isProcessing = false;
        if (data.resultType == "S") {
          this.visibleConfirmWithReason.close();
          this.isProcessing = true;

          this.isProcessing = true;
          this.trainingActionsList = [];
          let obj = {

            module: "TRN",
            status: this.selectedTrainingAction.status,
            isFrom: "All"
          }
          this.appService.getTaskDetailData(obj)
            .subscribe((data: any) => {
              this.trainingActionsList = data;
              this.isProcessing = false;
              this.initialCount = 0;
              this.pageCount = 4;
              this.isPrevious = false;
              if (this.pageCount < this.trainingActionsList.length) {
                this.isNext = true;
              } else if (this.pageCount >= this.trainingActionsList.length) {
                this.isNext = false;
              }
            })
          this.appService.getTrainingTaskDetails()
            .subscribe((data: any) => {
              this.trainingTaskDetails = data;
            })
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    })
  }
  authEnable(flag: string) {

    this.authService.loginPopup({
      scopes: ["User.Read"],
      prompt: "login"
    })
      .subscribe({
        next: (result) => {
          console.log(result.account?.username);
          let oldlooginuser = localStorage.getItem("loggedUserName")?.toUpperCase();
          let newuser = result.account?.username.toUpperCase();
          if (oldlooginuser === newuser) {
            console.log("inside");

            this.confirmWithFuncCall();


          } else {
            console.log("outside");
          }

        },
        error: (error) => {
          this.isProcessing = false;
          console.log(error)

        }
      });



  }

  confirmWithFunc() {
    if (this.tmsSettingsObj.esignatureAtTrainingUnlock == 'Y') {
      if (localStorage.getItem("adEnabled") == 'Y') {
        this.authEnable("adenabele")

      } else if (this.password == "") {
        this.buttonOperationFieldValidation();
        this.isProcessing = false;
      } else {
        let data = {
          userName: this.userName,
          password: this.password,
        }
        this.isProcessing = true;
        this.appService.validateUser(data).subscribe((data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.confirmWithFuncCall();
          } else {
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
          }
        })
      }
    } else {
      let data = {
        userTrainingId: this.trainingData.userTrainingId,
        dueDate: this.dueDate
      }
      this.isProcessing = true;
      this.appService.unlockTraining(data).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.visibleConfirmWithReason.close();
            this.isProcessing = true;
            const data1 = {

              module: 'TRN',
              status: this.selectedTrainingAction.status,
              isFrom: "All"
            };
            this.appService.getTaskDetail(data1)
              .subscribe((data: any) => {
                this.isProcessing = false;
                this.trainingActionsList = data;
              })
            this.appService.getTrainingTaskDetails()
              .subscribe((data: any) => {
                this.trainingTaskDetails = data;
              })
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      })
    }
  }
  pass: any;
  passRequiredMsg: any;
  buttonOperationFieldValidation() {
    this.pass = document.getElementById('pass') as HTMLInputElement;
    this.passRequiredMsg = document.getElementById('pass-required-msg') as HTMLInputElement;

    if (this.password == "") {
      this.pass.style.border = '1px solid red';
      this.passRequiredMsg.style.display = 'block';
    } else {
      this.pass.style.border = 'none';
      this.passRequiredMsg.style.display = 'none';
    }
  }

  cancelFunc() {
    this.visibleConfirmWithReason.close();
  }

  @ViewChild(DocumentViewerComponent) documentViewerComponent!: DocumentViewerComponent;
  docViewer!: DocViewerConfig;

  viewDoc(list: any) {
    this.isProcessing = true;
    console.log("list", list);

    try {
      // Determine content type from file extension
      const contentType = this.appService.getContentTypeByExtension(list.documentExtn);

      // Convert Base64 to Blob
      const blob = this.appService.base64ToBlob(list.document, contentType);

      // Prepare document object for WebViewer
      const doc = {
        body: blob,
        contentType: contentType,
        extn: list.documentExtn
      };

      this.docViewer = {
        blob,
        doc,
        docName: list.documentName,
        docExtension: list.documentExtn
      };

      // Open the viewer popup after slight delay
      setTimeout(() => {
        this.documentViewerComponent?.openPopUp();
      }, 0);

    } catch (err) {
      console.error('Error while decoding or preparing document:', err);
      alert('Failed to load document.');
    } finally {
      this.isProcessing = false;
    }
  }
  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }

  whereValsForExcel: any = "";
  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    this.manuallyPicked = false;
    this.selectedColumns = "";
  }
  selectedColumns: any;
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }
  manuallyPicked: boolean;
  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  pdfPageSizes: any = [];
  @Input() excelPdf: any = {};
  @ViewChild('pdf') pdf: MatSelect;
  pdfSelection = false;
  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }
  handleDropDownValidation(fieldId: string, selectedItems: any[]) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isExeclPdf = ['execl-pdf'].includes(fieldId);
    const isSelected = isExeclPdf ? !selectedItems.length : !selectedItems;
    const isFieldValid = field;
    if (isSelected && isFieldValid) {
      field.style.color = 'red';
    } else {
      field.style.color = '#005c8a';
    }
  }
  //Excell & PDF

  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  reportObj: any = {};
  toggleAllSelection(value: any) {
    if (value == 'pdf') {
      if (this.pdfSelection) this.pdf.options.forEach((item: MatOption) => item.select());
      else {
        this.pdf.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('execl-pdf', this.selectedColumns)
        this.convertArrayToString(this.selectedColumns);
      });
    } else if (value == 'columns') {
      if (this.isAllColumns) this.columns.options.forEach((item: MatOption) => item.select());
      else {
        this.columns.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }



  openReportPopup(item: any) {
    this.columnList = "User Name,User Fullname,Training Name,Version,Training Code,Training Type,Training Contents,Group Name,Status,Is User Active,Designation Code,Department Code,Manager Fullname,Trainer Name,User Training Status,Scheduled Training Status,Expiry Date,Due Date,Training Assigned On,Intimation Sent On,Started On,Completed On,Reminder Sent On,Escalation Sent On,Locked On,Failed Lock Rm Approved On,Overdue Lock Qa Approved On,Overdue Lock Rm Approved On,Start Date,End Date,Comments,Failed Attempts,Final Score";
    this.excelPdf.dropDown = this.columnList.split(',').map((column: any) => ({ valueExp: column, displayExp: column }));
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'My Training Report';
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    this.pdfSelection = false;
    this.reportName = "My Training Report"
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.isSaveReport = false;
  }

  reportName: any;
  isSaveReport: boolean = false;
  popupDataTitle: PopupData = {
    title: ''
  };

  selectedModuleType: string = '';
  filteredOptions: any[] = [];
  reportTemplateFieldValidation: any;
  reportLogoFieldValidation: any;
  templateid: number;
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }

    }
  }
  reportListDropdown: any[];
  pdfDetailSearchText: string = '';
  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;

  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      console.log("this.dropDownDataForReportLogo=", this.dropDownDataForReportLogo);
      console.log("this.dropDownDataForReportLogo.reportImageList", this.dropDownDataForReportLogo.reportImageList);
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            console.log("this.imageIdList=", this.imageIdList);
            console.log("this.organizationReportImageDetails=", this.organizationReportImageDetails.length);
            for (const detail of this.organizationReportImageDetails ?? []) {
              console.log("this.organizationReportImageDetails=", detail.reportImageId, this.imageIdList[i]);

              if (detail.reportImageId === this.imageIdList[i]) {

                this.reportLogoDropdown.push({
                  valueExp: detail.reportImageId,
                  displayExp: detail.reportImageName
                });
              }
            }
          }
        }
      } else {
        for (const detail of this.organizationReportImageDetails ?? []) {
          if (detail.reportImageId === this.dropDownDataForReportLogo?.reportImageList) {

            this.reportLogoDropdown.push({
              valueExp: detail.reportImageId,
              displayExp: detail.reportImageName
            });
          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const logoItem of this.reportLogoDropdown ?? []) {
          if (logoItem.valueExp === this.dropDownDataForReportLogo?.defaultReportName) {
            this.selectedReportLogoValue = logoItem.valueExp;
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }
  generateReport(value: any) {
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else {
      this.appService.isProcessingRep = true;
      let tname = "";
      let colList = "";
      let fieldList = "";
      let mod = "";


      tname = "TMS_USER_TRAININGS_REP_CNT_VW";
      colList = "USER_NAME,USR_FULLNAME,TRAINING_NAME,VERSION,TRAINING_CODE,TRAINING_TYPE,TRAINING_CONTENTS,GROUP_NAME,STATUS,IS_USER_ACTIVE,DESIGNATION_CODE,DEPARTMENT_CODE,MANAGER_FULLNAME,TRAINER_NAME,USER_TRAINING_STATUS,SCHEDULED_TRAINING_STATUS,EXPIRY_DATE,DUE_DATE,TRAINING_ASSIGNED_ON,INTIMATION_SENT_ON,STARTED_ON,COMPLETED_ON,INITIAL_ASSIGNED_ON,INITIAL_COMPLETED_ON,INITIAL_DUE_DATE,INITIAL_STARTED_ON,REMINDER_SENT_ON,ESCALATION_SENT_ON,LOCKED_ON,FAILED_LOCK_RM_APPROVED_ON,OVERDUE_LOCK_QA_APPROVED_ON,OVERDUE_LOCK_RM_APPROVED_ON,START_DATE,END_DATE,COMMENTS,FAILED_ATTEMPTS,FINAL_SCORE";
      fieldList = "User Name,User Fullname,Training Name,Version,Training Code,Training Type,Training Contents,Group Name,Status,Is User Active,Designation Code,Department Code,Manager Fullname,Trainer Name,User Training Status,Scheduled Training Status,Expiry Date,Due Date,Training Assigned On,Intimation Sent On,Started On,Completed On,Initial Assigned On,Initial Completed On,Initial Due Date,Initial Started On,Reminder Sent On,Escalation Sent On,Locked On,Failed Lock Rm Approved On,Overdue Lock Qa Approved On,Overdue Lock Rm Approved On,Start Date,End Date,Comments,Failed Attempts,Final Score";
      mod = "tms";
      this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId() + " AND USER_ID=" + this.message.getUserId() + " AND CONSIDERED_FOR_REPORT='Y'";


      const data = {

        groupId: this.qmsservice.selectedGroup
      }
      const data1: any = {

        tableOrViewName: tname,
        columnsList: colList,
        fieldLabelsList: fieldList,
        invisibleColumn: "",
        orderByClause: "",
        fieldSizeList: "",
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        status: this.statusCodeValue,
        codelistGroup: null,
        manualEntryDataFields: null,
        groupId: this.qmsservice.selectedActivityGroupId,
        chartStatus: null,
        wherVal: this.whereValsForExcel,
        reModule: mod,
        logoId: this.selectedReportLogoValue ?? 0,
        module: "TRN",
        footer: this.selectedReportFooter ?? null,
        isSaveRep: this.isSaveReport ? 'Y' : 'N',
        reportName: this.reportName ?? "Report",
        currentStatus: "NA",
        groupName: "",
      }
      this.reportObj = { ...data1, ...data };
      debugger;
      if (value == 'Excel') {
        const pdfData = {
          ...this.reportObj, title: this.selectedOption, columns: [],
          "informationTab": {
            "Report Name": "My Training Report",
            "Exported By": localStorage.getItem("loggedUserName")
          }
        }
        this.appService.downloadexcelForChart(pdfData, "Report.xlsx");
      } else {
        const pdfData = {
          ...this.reportObj, title: "My Training Report", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
        }
        this.appService.downloadPdfForChart(pdfData, "My Training Report.pdf");
      }

    }
  }
  selectedOption: any;
  statusCodeValue: any;
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  pdfSearchText: string = '';
  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.pdfSelection = this.selectedColumns.length == this.excelPdf.dropDown.length;
      });
    }
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;


  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    let str = "";
    if (this.selectedSubWizardofTeam == 'Not Completed') {
      str = this.selectedTeamTraining == null ? "" : "-" + this.selectedTeamTraining;
    }
    this.excelPdf.reportName = this.selectedSubWizardofTeam + str;
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }


  filteredTrainings: any[] = [];
  private _searchValue = '';
  get searchValue(): string {
    return this._searchValue;
  }
  set searchValue(value: string) {
    this._searchValue = value;
    this.applySearchFilter();
  }

  applySearchFilter() {
    if (this.searchValue) {
      const term = this.searchValue.toLowerCase().trim();
      this.filteredTrainings = this.searchedTrainingsList.filter((item: any) =>
        (item.trainingName?.toLowerCase().includes(term)) ||
        (item.trainingCode?.toLowerCase().includes(term)) ||
        (item.categoryCode?.toLowerCase().includes(term)) ||
        (item.type?.toLowerCase().includes(term)) ||
        (item.language?.toLowerCase().includes(term)) ||
        (item.groupName?.toLowerCase().includes(term))
      );
    } else {
      this.filteredTrainings = [...this.searchedTrainingsList];
    }
    // Reset pagination to page 1 after search
    this.collectionSize = this.filteredTrainings.length;
    this.setPage(1, 0);
  }

  setPage(page: number, targetpage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    // Determine which list to paginate: filtered or full
    const sourceList = this.filteredTrainings && this.filteredTrainings.length > 0
      ? this.filteredTrainings
      : this.searchedTrainingsList;

    // Guard: if sourceList is empty, reset pagedItems and return
    if (!sourceList || sourceList.length === 0) {
      this.pagedItems = [];
      this.pager = {};
      return;
    }

    // Apply pagination on the correct list
    this.pager = this.paginationService.getPager(sourceList.length, page, this.perPage, targetpage);
    this.pagedItems = sourceList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  reportFooterfieldValidation1: any;
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterfieldValidation1 != undefined) {
        this.reportFooterfieldValidation1.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next:
        (data: any) => {
          this.reportFooterDropdown1 = data;

          this.selectBoxForFooter();
          if (this.reportFooterDropdown.length > 0) {
            this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
          }
        }, error:
        (error: any) => {
          this.isProcessing = false;
        }
    }
    );
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes("AU")) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
      }
    }
  }

  fetchAiData(type: string) {
    this.isProcessing = true;
    this.activeApi = type;
    this.rawJsonResponse = null;

    let apiCall;
    switch (type) {
      case 'Trainings':
        apiCall = this.appService.getAllAiTrainings();
        break;
      case 'TrainingContents':
        apiCall = this.appService.getAllAiTrainingContents();
        break;
      case 'UserTrainingContents':
        apiCall = this.appService.getAllAiUserTrnContents();
        break;
      case 'TrainingQuestions':
        apiCall = this.appService.getAllAiTrnQuestions();
        break;
    }

    if (apiCall) {
      apiCall.subscribe({
        next: (data: any) => {
          this.rawJsonResponse = data;
          this.isProcessing = false;
        },
        error: (err: any) => {
          this.rawJsonResponse = { error: 'Failed to fetch data', details: err.message };
          this.isProcessing = false;
        }
      });
    }
  }
}
